/**
 * @Name：admin axios请求模块
 * @Author：syy
 * @description：服务于api，统一设置axios参数
 */
import vm from '../main.js'
import axios from "axios";
import {
	errorCallback
} from "@/error";
import {
	setter
} from '@/config';
import {
	getToken
} from "@/utils";
import {
	Message
} from 'element-ui';
import router from "@/router";
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json';
let request = axios.create({
	baseURL: setter.baseURL,
	//baseURL:BASE_URL,
	transformRequest: [function(data) {
		data = JSON.stringify(data);
		return data;
	}],
});
// 添加一个请求拦截器
request.interceptors.request.use(
	/**
	 * @description 从Session中获取token，并在接口访问时统一加入请求体
	 */
	function(config) {
		// config.headers["token"] = '9cfab969358a57630f27913cd4130055';
		config.data = config.data || {};
		config.data['admin_token'] = localStorage.getItem('token');
		return config;
	},
	function(error) {
		//Do something with request error
		//Message.error({message : '请求超时!'});
		return Promise.resolve(error);
	});
// 添加一个响应拦截器
request.interceptors.response.use(
	/**
	 * @description 对相应体数据进行处理，成功的请求返回data，失败的请求进入错误处理模块
	 */
	function(response) {
		//Do something with response data
		let responseData = response.data;
		let data = responseData.responseObj || responseData.responseList || responseData.responseUrl;
		let state = response.status;
		let msg = responseData.message;
		if (responseData.status === -1) {
			Message.error(msg);
		}
		if (responseData.status === 200) {
			return responseData;
		}
		if (responseData.status === -200) {
			router.push({
				path: '/'
			})
		}
		// if (responseData.status === -100) {
		// 	Message.error(msg);
		// 	setTimeout(()=>{
		// 		router.push({
		// 			path: '/certifyInfo/index'
		// 		})
		// 	})
		// }
		// 错误处理模块
		errorCallback(state, msg);
		// 错误处理模块
	},
	function(error) {
		//Loading.service().close();
		// Do something with response error
		if (error.response.status === 504 || error.response.status === 404) {
			//Message.error({message : '服务器被吃了⊙﹏⊙∥'});
		} else if (error.response.status === 403) {
			//Message.error({message : '权限不足,请联系管理员!'});
		} else if (error.response.status === 401) {
			// syy
			// vm.$store.dispatch("logOut").then(() => {
			//   vm.$router.push('/');
			// });
		} else {
			// Message.error({message : '未知错误'});
		}
		return Promise.reject(error);
	});
export default request;